import { useEffect, useState } from "react"

const useMobileDetection = () => {
  const [isMobile, setIsMobile] = useState()

  useEffect(() => {
    const desktopWidth = 1024
    const scrollBarWidth = window.innerWidth - document.body.clientWidth

    window.innerWidth + scrollBarWidth < desktopWidth
      ? setIsMobile(true)
      : setIsMobile(false)

    const windowResizeObserver = new ResizeObserver(entries => {
      entries.forEach(entry => {
        entry.contentRect.width + scrollBarWidth < desktopWidth
          ? setIsMobile(true)
          : setIsMobile(false)
      })
    })

    windowResizeObserver.observe(document.body)
    return () => {
      windowResizeObserver.unobserve(document.body)
    }
  }, [isMobile])

  return isMobile
}

export default useMobileDetection
